/**
 * Minimal local `formToObject` — serialises a <form>'s named controls into a
 * plain object (repeated names → arrays; the listing engine then comma-joins
 * array values).
 *
 * Replaces the external `form_to_object` jsdelivr CDN script the listing engine
 * used to rely on. That script was only enqueued for the legacy
 * `acf/card-grid-with-filters` block name (see app/filters.php), so thin per-CPT
 * index blocks (e.g. `acf/resources-index`) never loaded it and all client-side
 * filter serialisation threw `ReferenceError: formToObject is not defined`. A
 * per-page external CDN request is also a privacy concern on this privacy-first
 * site. Bundling it here (global, always present) fixes both.
 *
 * @param {HTMLFormElement} form
 * @param {{ includeEmptyValuedElements?: boolean }} [opts]
 * @returns {Object}
 */
window.formToObject = function ( form, opts = {} ) {
	const includeEmpty = !! opts.includeEmptyValuedElements;
	const result = {};

	if ( ! form || ! form.elements ) {
		return result;
	}

	Array.from( form.elements ).forEach( el => {
		const name = el.name;
		if ( ! name || el.disabled ) {
			return;
		}

		//radios / checkboxes only contribute their value when checked
		if ( ( el.type === 'radio' || el.type === 'checkbox' ) && ! el.checked ) {
			return;
		}

		const value = el.value;
		if ( value === '' && ! includeEmpty ) {
			return;
		}

		if ( result[ name ] === undefined ) {
			result[ name ] = value;
		} else if ( Array.isArray( result[ name ] ) ) {
			result[ name ].push( value );
		} else {
			result[ name ] = [ result[ name ], value ];
		}
	} );

	return result;
};
